import React,{useState}  from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {HiOutlineLocationMarker} from 'react-icons/hi';

const cityArr = ['Mumbai, Maharstra', 'Pune, Maharastra', 'Delhi, Delhi', 'Noida, Uttar Pradesh', 'Hyderabad, Telangana', 'Secundrabad, Telangana',  'Chandigarh, Punjab/Haryana', 'Howrah ,West Bengal', 'Kolkata, West Bengal' ];
export default function CityBusMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCity = (e)=>{
    props.setterFunc(e.target.id);
    props.removeMenu(false);
    setAnchorEl(null);
  }

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{color: 'red', fontSize:'40px', width:'80vw', height:'150px', backgroundColor:'transparent'}}
      >
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      ><>
        {cityArr.map(el=>{
            return <MenuItem onClick={handleCity} sx={{width:'80vw'}} id={el}><><HiOutlineLocationMarker />{el}</></MenuItem>
        })
        }</>
      </Menu>
    </div>
  );
}